import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { useAppSelector } from 'app/hooks'
import { format } from 'date-fns'
import React, { useEffect, useMemo, useState } from 'react'
import { QrReader } from 'react-qr-reader'
import EventCard from './EventCard'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: JSX.Element
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

export default function QRCheck() {
  const [open, setOpen] = useState(false)
  const [text, setText] = useState('')
  const [checkCount, setCheckCount] = useState(0)
  const events = useAppSelector((s) => s.Event.list)
  useEffect(() => {
    return () => {
      setOpen(false)
    }
  }, [])
  useEffect(() => {
    if (!open) {
      setText('')
      setCheckCount(0)
    }
  }, [open])
  useEffect(() => {
    if (checkCount >= 60) {
      setOpen(false)
    }
  }, [checkCount])

  const eventInfo = useMemo(() => {
    if (events && Number(text)) {
      return events.find((f) => f.id === Number(text))
    }
  }, [text, events])
  return (
    <>
      <IconButton
        sx={{
          mx: 2,
          color: '#fff',
          transition: '500ms',
          '&:hover': {
            transform: 'scale(1.5)',
          },
        }}
        onClick={() => setOpen(!open)}
      >
        <QrCodeScannerIcon />
      </IconButton>
      <Dialog
        open={open}
        fullWidth
        TransitionComponent={Transition}
        maxWidth="md"
        onClose={(_e, _reason) => {
          setOpen(false)
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>QRコード読み取り</DialogTitle>
        <DialogContent>
          <Stack
            spacing={1}
            sx={{
              position: 'relative',
              '&>section>div': {
                paddingTop: '80% !important',
              },
            }}
          >
            {open && !eventInfo && (
              <QrReader
                scanDelay={1000}
                onResult={(result, error) => {
                  if (!!result && result.getText()) {
                    setText(result.getText())
                    setCheckCount(0)
                  }

                  if (!!error) {
                    setCheckCount((pre) => pre + 1)
                  }
                }}
                constraints={{ facingMode: 'environment' }}
              />
            )}
            {eventInfo && (
              <EventCard
                to={'#'}
                place={eventInfo.address}
                title={eventInfo.name}
                time={`${format(eventInfo.startDate, 'yyyy/MM/dd')} ～ ${format(
                  eventInfo.endDate,
                  'yyyy/MM/dd'
                )}`}
                summary={eventInfo.summary}
                src={eventInfo.image}
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          {eventInfo ? (
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-around"
              className="mb-4"
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setText('')}
              >
                再読み込み
              </Button>
              {/* <Link to={"#"} onClick={() => setOpen(false)}>
                <Button variant="contained" color="primary">
                  移動する
                </Button>
              </Link> */}
            </Stack>
          ) : (
            <Stack width="100%" direction="row" justifyContent="center">
              <Button
                variant="outlined"
                color="warning"
                onClick={() => setOpen(false)}
              >
                閉じる
              </Button>
            </Stack>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}
